import './index.css'
import './posthog'

import { ConvexAuthProvider } from '@convex-dev/auth/react'
import { ConvexReactClient } from 'convex/react'
import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import ConvexGlobalErrorHandler from './components/ConvexGlobalErrorHandler'

const convexUrl =
  import.meta.env.VITE_CUSTOM_DOMAIN_CONVEX_URL ??
  import.meta.env.VITE_CONVEX_URL

console.log('🔧 Initializing Convex client with URL:', convexUrl)
console.log('🔧 VITE_CONVEX_URL:', import.meta.env.VITE_CONVEX_URL)
console.log(
  '🔧 VITE_CUSTOM_DOMAIN_CONVEX_URL:',
  import.meta.env.VITE_CUSTOM_DOMAIN_CONVEX_URL,
)

const convex = new ConvexReactClient(convexUrl)

// Global handler for unhandled promise rejections from Convex
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason
  console.error('Unhandled promise rejection:', error)

  // Check if this is a 2FA verification error from Convex
  if (
    error?.message?.includes('2FA verification required') ||
    error?.message?.includes('Not authenticated')
  ) {
    console.log(
      '2FA session expired (unhandled promise), redirecting to login...',
    )
    event.preventDefault() // Prevent default error handling
    window.location.href = '/admin/login'
  }

  // Handle token refresh failures (Failed to fetch errors)
  if (
    error instanceof TypeError &&
    error.message?.includes('Failed to fetch') &&
    (error.stack?.includes('@convex-dev/auth') ||
      error.stack?.includes('verifyCodeAndSetToken'))
  ) {
    console.log(
      'Token refresh failed after inactivity, clearing session and reloading...',
    )
    event.preventDefault() // Prevent default error handling
    // Clear any stored auth state and reload
    localStorage.removeItem('convex-auth')
    sessionStorage.clear()
    window.location.reload()
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConvexGlobalErrorHandler>
      <ConvexAuthProvider client={convex}>
        <App />
      </ConvexAuthProvider>
    </ConvexGlobalErrorHandler>
  </React.StrictMode>,
)
